import { refElements } from 'components/Canvas/renderer/utils/elementUtils'
import blocks from 'assets/icons/Block.png'
import Button from 'assets/icons/Button.png'
import Card from 'assets/icons/Card.png'
import CategoryMenus from 'assets/icons/CategoryMenus.png'
import Column from 'assets/icons/Column.png'
import Container from 'assets/icons/Container.png'
import TextEditor from 'assets/icons/TextEditor.png'
import Youtube from 'assets/icons/YouTube.png'
import Image from 'assets/icons/Image.png'
import Section from 'assets/icons/Section.png'
import Slider from 'assets/icons/Slider.png'
import Title from 'assets/icons/Title.png'
import Divider from 'assets/icons/Divider.png'
import Countdown from 'assets/icons/Stopwatch.jpg'
import Product from 'assets/icons/Product Card.jpg'
import ProductSlider from 'assets/icons/Product_slider.jpg'
import storeTemplate1 from 'assets/icons/superdry/Custom_temp_1.png'
import storeTemplate2 from 'assets/icons/superdry/Custom_temp_2.png'
import storeTemplate3 from 'assets/icons/superdry/Custom_temp_3.png'
import storeTemplate4 from 'assets/icons/superdry/Custom_temp_4.jpg'
import storeTemplate5 from 'assets/icons/superdry/Custom_temp_5.png'
import Column2 from 'assets/icons/ColumnPanel/2Column.png'
import Column3 from 'assets/icons/ColumnPanel/3Column.png'
import Column4 from 'assets/icons/ColumnPanel/4_Column.png'
import Column6 from 'assets/icons/ColumnPanel/6_Column.png'
import Column12 from 'assets/icons/ColumnPanel/12_Column.png'
import Desktop from 'assets/icons/ColumnPanel/DK_Layout*5.png'
import Tablet from 'assets/icons/ColumnPanel/TB_Layout*5.png'
import Mobile from 'assets/icons/ColumnPanel/phone_Layout*5.png'
import Stacked from 'assets/icons/ColumnPanel/Stacked.png'

export const STORE_TEMPLATE_ICONS = {
  superdry: {
    template1: storeTemplate1,
    template2: storeTemplate2,
    template3: storeTemplate4,
    template4: storeTemplate3,
    template5: storeTemplate5,
  },
  asavasopon: {
    template1: storeTemplate1,
    template2: storeTemplate2,
    template3: storeTemplate4,
    template4: storeTemplate3,
    template5: storeTemplate5,
  },
  mcshop: {
    template1: storeTemplate1,
    template2: storeTemplate2,
    template3: storeTemplate4,
    template4: storeTemplate3,
    template5: storeTemplate5,
  },
}

export const ColumnPanelIcons = {
  gridOptions: [
    {
      source: Column2,
      label: '2 Columns',
      value: 2,
    },
    {
      source: Column3,
      label: '3 Columns',
      value: 3,
    },
    {
      source: Column4,
      label: '4 Columns',
      value: 4,
    },
    {
      source: Column6,
      label: '6 Columns',
      value: 6,
    },
    {
      source: Column12,
      label: '12 Columns',
      value: 12,
    },
  ],
  iconHeader: {
    computer: Desktop,
    tablet: Tablet,
    mobile: Mobile,
  },
  iconPhone: [
    {
      source: Stacked,
      label: 'Stacked',
    },
    {
      source: Column2,
      label: '2 Columns',
    },
  ],
}

export default {
  [refElements.DIV]: blocks,
  [refElements.BUTTON]: Button,
  [refElements.CARD]: Card,
  [refElements.CATEGORY_MENUS]: CategoryMenus,
  [refElements.COLUMNS]: Column,
  [refElements.CONTAINER]: Container,
  [refElements.IMAGE]: Image,
  [refElements.SECTION]: Section,
  [refElements.IMAGE_CAROUSEL]: Slider,
  [refElements.TEXT]: Title,
  [refElements.DIVIDER]: Divider,
  [refElements.COUNT_DOWN]: Countdown,
  [refElements.PRODUCT_CARD]: Product,
  [refElements.YOUTUBE]: Youtube,
  [refElements.PRODUCT_SLIDER]: ProductSlider,
  [refElements.TEXT_EDITOR]: TextEditor,
}



// WEBPACK FOOTER //
// ./src/helpers/icons.js